import RoutePlanActionTypes from "./route-planning.types";

const INITIAL_STATE = {
	// general
	error: null,
	loading: false,
	singular: null,
	plural: [],
};

const routeReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case RoutePlanActionTypes.CLEAR_ERROR:
			return {
				...state,
				error: null,
			};
		case RoutePlanActionTypes.FETCH_ROUTE_PLAN_START:
		case RoutePlanActionTypes.CREATE_ROUTE_PLAN_START:
			return {
				...state,
				loading: true,
			};
		case RoutePlanActionTypes.FETCH_ROUTE_PLAN_FAILURE:
		case RoutePlanActionTypes.CREATE_ROUTE_PLAN_FAILURE:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		case RoutePlanActionTypes.CREATE_ROUTE_PLAN_SUCCESS:{
			return {
				...state,
				loading: false,
			};
		}
		case RoutePlanActionTypes.FETCH_ROUTE_PLAN_SUCCESS: {
			return {
				...state,
				plural: action.payload,
				loading: false,
			};
		}
		default:
			return state;
	}
};

export default routeReducer;
